import React, {createContext, useContext, useMemo} from 'react';

import {useWorkspaceRefsContext} from '../Workspace/WorkspaceRefsContext';
import {useAutoSyncPanelBank} from './hooks/useAutoSyncPanelBank';

type AutoSyncPanelBankContextProviderProps = {
  children: React.ReactNode;
};

type AutoSyncPanelBankContextType = {
  isLoading: boolean;
};

const AutoSyncPanelBankContext = createContext<
  AutoSyncPanelBankContextType | undefined
>(undefined);

export const AutoSyncPanelBankContextProvider = ({
  children,
}: AutoSyncPanelBankContextProviderProps) => {
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const {loading: isLoading} = useAutoSyncPanelBank(panelBankConfigRef);

  const value = useMemo(
    () => ({
      isLoading,
    }),
    [isLoading]
  );

  return (
    <AutoSyncPanelBankContext.Provider value={value}>
      {children}
    </AutoSyncPanelBankContext.Provider>
  );
};

export const useAutoSyncPanelBankContext = () => {
  const value = useContext(AutoSyncPanelBankContext);

  if (value == null) {
    throw new Error(
      'useAutoSyncPanelBankContext must be used within an AutoSyncPanelBankContext'
    );
  }

  return value;
};
